import { FC } from "react";
import { Router } from "routes";

export const App: FC = (): JSX.Element => {
  return <Router />;
};

export default App;
